import controller from './chart-co2-only.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};
